import { api } from "./api";

export interface Notification {
  _id: string;
  user: string;
  title: string;
  content: string;
  type: string;
  link?: string;
  isRead: boolean;
  createdAt: string;
}

export const notificationApi = {
  // Get current user's notifications
  getNotifications: (options?: { page?: number; limit?: number; unreadOnly?: boolean }) => {
    const params = new URLSearchParams();
    if (options?.page) params.append("page", String(options.page));
    if (options?.limit) params.append("limit", String(options.limit));
    if (options?.unreadOnly) params.append("unreadOnly", "true");

    return api.get<{ success: boolean; data: Notification[]; pagination: any; unreadCount: number }>(
      `/notifications${params.toString() ? `?${params.toString()}` : ""}`
    );
  },

  // Get unread notification count
  getUnreadCount: () => {
    return api.get<{ success: boolean; unreadCount: number }>("/notifications/unread-count");
  },

  // Mark a notification as read
  markAsRead: (notificationId: string) => {
    return api.put<{ success: boolean; data: Notification }>(`/notifications/${notificationId}/read`);
  },

  // Mark all notifications as read
  markAllAsRead: () => {
    return api.put<{ success: boolean; message: string }>("/notifications/read-all");
  },

  // Delete a notification
  deleteNotification: (notificationId: string) => {
    return api.delete<{ success: boolean; message: string }>(`/notifications/${notificationId}`);
  },

  // Clear all notifications
  clearAll: () => {
    return api.delete<{ success: boolean; message: string }>("/notifications/clear-all");
  },
};